import { featuredComics } from './home';

export const categoryComics = [
  ...featuredComics,
  {
    id: 9,
    title: '星辰变',
    author: '天蚕',
    category: '古风仙侠',
    categorySlug: 'xianxia',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manga%20cover%2C%20young%20cultivator%20ascending%20to%20heavens%20with%20dramatic%20spiritual%20energy%2C%20ancient%20Chinese%20cosmic%20landscape%2C%20swirling%20clouds%20and%20stars%2C%20majestic%20and%20epic%20illustration%20style%2C%20clean%20gradient%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-star-change-09&orientation=portrait',
    description: '少年秦羽历经磨难，从凡人一步步修炼成仙，踏遍三界，书写属于自己的传奇。',
    chapters: 312,
    views: '2100万',
    rating: 9.6,
    isNew: false,
    tags: ['经典', '仙侠'],
  },
  {
    id: 10,
    title: '末世寄生者',
    author: '暗夜',
    category: '科幻未来',
    categorySlug: 'scifi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20post-apocalyptic%20sci-fi%20manga%20cover%2C%20lone%20survivor%20in%20ruined%20cityscape%20with%20bioluminescent%20alien%20organisms%2C%20dark%20atmospheric%20scene%20with%20neon%20green%20glow%2C%20gritty%20detailed%20illustration%20style%2C%20clean%20dark%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-apocalypse-10&orientation=portrait',
    description: '末日降临，外星寄生生物入侵地球。幸存者林越意外获得了与寄生体共生的能力，在这个残酷的新世界艰难求生。',
    chapters: 67,
    views: '520万',
    rating: 9.4,
    isNew: true,
    tags: ['科幻', '热血'],
  },
  {
    id: 11,
    title: '恋爱方程式',
    author: '糖豆',
    category: '恋爱甜宠',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manga%20cover%2C%20high%20school%20couple%20sharing%20earphones%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20and%20warm%20golden%20lighting%2C%20dreamy%20romantic%20atmosphere%2C%20gentle%20pastel%20illustration%20style%2C%20clean%20simple%20light%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-love-11&orientation=portrait',
    description: '理工男学霸 x 艺术系女神，当理性撞上感性，一场充满笑与泪的校园恋爱公式就此展开。',
    chapters: 89,
    views: '730万',
    rating: 9.5,
    isNew: false,
    tags: ['甜宠', '校园'],
  },
  {
    id: 12,
    title: '篮球少年',
    author: '七月',
    category: '校园青春',
    categorySlug: 'school',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sports%20manga%20cover%2C%20teenage%20basketball%20player%20making%20dramatic%20slam%20dunk%2C%20dynamic%20action%20pose%20with%20sweat%20and%20motion%20trails%2C%20vibrant%20energetic%20warm%20colors%2C%20exciting%20shonen%20style%20illustration%2C%20clean%20gradient%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-basketball-12&orientation=portrait',
    description: '身高不足170cm的少年，凭借着惊人的毅力和天赋，在高中篮球界掀起风暴！热血青春，燃到爆！',
    chapters: 145,
    views: '890万',
    rating: 9.6,
    isNew: false,
    tags: ['热血', '青春'],
  },
  {
    id: 13,
    title: '山海异闻录',
    author: '苏九',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manga%20cover%2C%20mystical%20creatures%20from%20Chinese%20mythology%20roaming%20ancient%20mountain%20landscape%2C%20phoenix%20and%20nine-tailed%20fox%20in%20dramatic%20lighting%2C%20rich%20traditional%20art%20influence%20with%20modern%20manga%20style%2C%20clean%20atmospheric%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-shanhai-13&orientation=portrait',
    description: '少年拥有一本能看见山海异兽的古老图谱，跟随图谱指引踏上寻找失落的异兽之旅。',
    chapters: 98,
    views: '560万',
    rating: 9.5,
    isNew: true,
    tags: ['奇幻', '冒险'],
  },
  {
    id: 14,
    title: '推理咖啡馆',
    author: '林深',
    category: '悬疑推理',
    categorySlug: 'mystery',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20manga%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20dimly%20lit%20vintage%20cafe%2C%20clues%20scattered%20on%20table%2C%20atmospheric%20noir%20lighting%20with%20warm%20amber%20tones%2C%20intricate%20illustration%20with%20subtle%20suspense%20elements%2C%20clean%20dark%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-detective-14&orientation=portrait',
    description: '一家只在午夜营业的神秘咖啡馆，每个客人都会带来一个未解之谜。店主以咖啡换故事，用推理揭开真相。',
    chapters: 56,
    views: '340万',
    rating: 9.3,
    isNew: true,
    tags: ['推理', '悬疑'],
  },
  {
    id: 15,
    title: '猫的报恩',
    author: '暖暖',
    category: '治愈日常',
    categorySlug: 'slice-of-life',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20slice%20of%20life%20manga%20cover%2C%20cute%20fluffy%20cats%20gathering%20around%20a%20young%20woman%20in%20cozy%20apartment%2C%20warm%20sunlight%20through%20window%2C%20heartwarming%20and%20peaceful%20atmosphere%2C%20soft%20watercolor%20texture%20illustration%20style%2C%20clean%20warm%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-cat-15&orientation=portrait',
    description: '独居女孩收养了一只流浪猫之后，生活发生了翻天覆地的变化。原来每一只猫，都是来报恩的小天使。',
    chapters: 45,
    views: '280万',
    rating: 9.4,
    isNew: false,
    tags: ['治愈', '萌宠'],
  },
  {
    id: 16,
    title: '疯人院日常',
    author: '糖豆',
    category: '搞笑日常',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20manga%20cover%2C%20chaotic%20funny%20scene%20in%20mental%20hospital%20setting%20with%20exaggerated%20cartoon%20expressions%2C%20bright%20colorful%20and%20energetic%20illustration%2C%20over-the-top%20humorous%20characters%2C%20playful%20manga%20style%2C%20clean%20light%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-crazy-16&orientation=portrait',
    description: '一群"不太正常"的室友们的爆笑日常。如果你觉得他们疯了，那可能是因为你还没搬进来！',
    chapters: 120,
    views: '1100万',
    rating: 9.5,
    isNew: false,
    tags: ['搞笑', '日常'],
  },
];

export const categoryDescriptions: Record<string, { title: string; description: string; heroQuery: string }> = {
  fantasy: {
    title: '奇幻冒险',
    description: '探索充满魔法与奇幻元素的精彩世界，跟随主角们踏上惊心动魄的冒险旅程。从东方玄幻到西方魔幻，这里汇集了最优秀的奇幻冒险漫画作品。',
    heroQuery: 'Chinese fantasy adventure manga panoramic illustration, magical world with floating islands and mythical creatures, warm golden lighting, epic scale composition, dreamy and whimsical atmosphere, clean artistic style&width=1600&height=600&seq=cat-hero-fantasy&orientation=landscape',
  },
  xianxia: {
    title: '古风仙侠',
    description: '修仙问道，仗剑天涯。在仙侠的世界里，见证凡人逆天改命、修炼成仙的传奇故事。古风画风与仙侠世界观完美融合。',
    heroQuery: 'Chinese xianxia cultivation world panoramic illustration, ancient mountain peaks shrouded in mist, flying swords and immortal palaces, traditional Chinese ink painting style with golden accents, serene and majestic atmosphere&width=1600&height=600&seq=cat-hero-xianxia&orientation=landscape',
  },
  action: {
    title: '热血战斗',
    description: '燃爆的战斗场面、扣人心弦的对决！从武道巅峰到超能力大战，每一页都让你肾上腺素飙升。',
    heroQuery: 'Chinese action battle manga panoramic illustration, epic martial arts combat with dynamic energy effects and dramatic lighting, warriors in intense fighting poses, powerful and explosive atmosphere, bold illustration style&width=1600&height=600&seq=cat-hero-action&orientation=landscape',
  },
  mystery: {
    title: '悬疑推理',
    description: '步步惊心的悬疑剧情，烧脑的推理过程。每一个细节都可能是破案的关键，跟随主角揭开层层谜团。',
    heroQuery: 'Chinese mystery thriller manga panoramic illustration, dark rainy alley with mysterious shadows and subtle clues scattered, atmospheric noir lighting with cool tones, suspenseful and intriguing composition, clean artistic style&width=1600&height=600&seq=cat-hero-mystery&orientation=landscape',
  },
  scifi: {
    title: '科幻未来',
    description: '探索宇宙奥秘，畅想未来科技。从星际旅行到人工智能，这里有你想象不到的科幻世界。',
    heroQuery: 'Chinese sci-fi futuristic manga panoramic illustration, massive space station orbiting distant planet with colorful nebula, advanced technology and sleek design, awe-inspiring cosmic atmosphere, clean modern illustration style&width=1600&height=600&seq=cat-hero-scifi&orientation=landscape',
  },
  comedy: {
    title: '搞笑日常',
    description: '笑到停不下来！轻松搞笑的日常故事，夸张的表情和爆笑的剧情，让你忘记一切烦恼。',
    heroQuery: 'Chinese comedy manga panoramic illustration, colorful and playful scene with funny characters in exaggerated situations, bright cheerful warm colors, energetic and humorous atmosphere, lively cartoon illustration style&width=1600&height=600&seq=cat-hero-comedy&orientation=landscape',
  },
  'slice-of-life': {
    title: '治愈日常',
    description: '温暖治愈的日常故事，细腻的情感描绘。在平凡的生活中发现不平凡的美好瞬间。',
    heroQuery: 'Chinese slice of life manga panoramic illustration, peaceful neighborhood street with cherry blossoms falling, warm gentle sunlight creating soft shadows, heartwarming and calming atmosphere, soft watercolor illustration style&width=1600&height=600&seq=cat-hero-slice&orientation=landscape',
  },
  horror: {
    title: '惊悚恐怖',
    description: '胆量挑战！精心设计的恐怖氛围和细思极恐的剧情，让你在安全的屏幕前也能感受到脊背发凉的刺激。',
    heroQuery: 'Chinese horror manga panoramic illustration, eerie abandoned mansion at night with faint ghostly figures in windows, cold blue moonlight casting long shadows, chilling and suspenseful atmosphere, dark atmospheric illustration style&width=1600&height=600&seq=cat-hero-horror&orientation=landscape',
  },
  romance: {
    title: '恋爱甜宠',
    description: '甜到掉牙的恋爱故事！从校园初恋到都市情缘，每一段恋情都让人心动不已。',
    heroQuery: 'Chinese romance manga panoramic illustration, couple walking hand in hand through flower field at sunset, warm golden pink sky, dreamy romantic atmosphere with floating flower petals, soft gentle illustration style&width=1600&height=600&seq=cat-hero-romance&orientation=landscape',
  },
  school: {
    title: '校园青春',
    description: '重返青春校园，感受最纯粹的友谊和梦想。热血运动、青涩初恋、奋斗备考...你的青春记忆都在这里。',
    heroQuery: 'Chinese school life manga panoramic illustration, vibrant high school campus with students enjoying club activities, cherry blossom trees in full bloom, bright energetic spring atmosphere, youthful and lively illustration style&width=1600&height=600&seq=cat-hero-school&orientation=landscape',
  },
};